import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页', icon: 'ri-home-4-line' },
  { path: '/category/all', label: '分类', icon: 'ri-apps-line' },
  { path: '/about', label: '关于我们', icon: 'ri-information-line' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const closeMobile = useCallback(() => setMobileOpen(false), []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 cursor-pointer"
            onClick={closeMobile}
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-movie-2-line text-2xl text-primary-500"></i>
            </div>
            <span className="font-heading text-xl font-bold text-foreground-950">
              小草影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative whitespace-nowrap text-sm font-medium transition-colors cursor-pointer ${
                  (link.path === '/' && location.pathname === '/') ||
                  (link.path !== '/' && location.pathname.startsWith(link.path))
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                {link.label}
                {((link.path === '/' && location.pathname === '/') ||
                  (link.path !== '/' && location.pathname.startsWith(link.path))) && (
                  <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-4 h-0.5 bg-primary-500 rounded-full" />
                )}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索电视剧..."
                className="w-48 pl-8 pr-3 py-1.5 text-sm bg-background-100 border border-background-200/70 rounded-full text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 transition-all"
              />
              <div className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-sm text-foreground-400"></i>
              </div>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-800"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={closeMobile}
                className={`px-3 py-2.5 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  (link.path === '/' && location.pathname === '/') ||
                  (link.path !== '/' && location.pathname.startsWith(link.path))
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="relative mt-2">
              <input
                type="text"
                placeholder="搜索电视剧..."
                className="w-full pl-9 pr-4 py-2 text-sm bg-background-100 border border-background-200/70 rounded-full text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300"
              />
              <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-sm text-foreground-400"></i>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}